import CreateRankPromotion from './CreateRankPromotion.container';

export default CreateRankPromotion;
